import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { APISetting, Setting, SftpSetting } from '../../core/models/setting.model';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class SettingsService {

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
  }

  getSettings() {
    return this.http.get<Setting[]>(`/api/setting`);
  }

  getGeneralSettings() {
    return this.http.get<any>(`/api/setting/General`);
  }

  getSettingById(id: string) {
    return this.http.get<Setting>(`/api/setting/${id}`);
  }

  updateSettingById(id: string, settings: Setting) {
    return this.http.put<Setting>(`/api/setting/${id}`, settings);
  }

  updateApiSettings(id: string, settings: APISetting) {
    return this.http.put(`/api/setting/${id}/apisetting`, settings);
  }

  getApiSettings(id: string): Observable<APISetting> {
    return this.http.get<APISetting>(`/api/setting/${id}/apisetting`);
  }

  UploadUserAttributes(data: FormData) {
      return this.http.post<any> ('/api/D2lField/FileUpload', data);  
  }  

  getSftpSettings(id: string): Observable<SftpSetting> {
    return this.http.get<SftpSetting>(`/api/setting/${id}/sftpsetting`);
  }

  updateSftpSettings(id: string, settings: SftpSetting) {
    return this.http.put(`/api/setting/${id}/sftpsetting`, settings);
  }
}

